import * as actionType from "./action";

export function analysisReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ANALYSIS_SUCCESS:
      return { ...state, response };
    case actionType.GET_ANALYSIS_ERROR:
      return { ...state, response };
    case actionType.ADD_ANALYSIS_SUCCESS:
      return state;
    case actionType.ADD_ANALYSIS_ERROR:
      return { ...state, response };
    case actionType.MODIFY_ANALYSIS_SUCCESS:
      return state;
    case actionType.MODIFY_ANALYSIS_ERROR:
      return { ...state, response };
    case actionType.DELETE_ANALYSIS_SUCCESS:
      return state;
    case actionType.DELETE_ANALYSIS_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function analysesReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ANALYSES_SUCCESS:
      return { ...state, response };
    case actionType.GET_ANALYSES_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function analysisTeamsReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ANALYSIS_TEAMS_SUCCESS:
      return { ...state, response };
    case actionType.GET_ANALYSIS_TEAMS_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function analysisTeamReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_ANALYSIS_TEAM_SUCCESS:
      return { ...state, response };
    case actionType.GET_ANALYSIS_TEAM_ERROR:
      return { ...state, response };
    case actionType.ADD_ANALYSIS_TEAM_SUCCESS:
      return state;
    case actionType.ADD_ANALYSIS_TEAM_ERROR:
      return { ...state, response };
    case actionType.DELETE_ANALYSIS_TEAM_SUCCESS:
      return state;
    case actionType.DELETE_ANALYSIS_TEAM_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
